
export const FETCH_SYNTHESE_REQUEST = 'FETCH_SYNTHESE_REQUEST';
export const FETCH_SYNTHESE_SUCCESS = 'FETCH_SYNTHESE_SUCCESS';
export const FETCH_SYNTHESE_FAILURE = 'FETCH_SYNTHESE_FAILURE';
export const REDIRECT_TO_LOGIN = 'REDIRECT_TO_LOGIN';